import React from 'react'
import { FacetSelect } from '../BaseComponents/FacetSelect'

const SkillFacetInput: React.FC = () => (
  <FacetSelect
    source="skillFacet"
    facetCategory="productFilter"
    filterGroup="Skill"
  />
)

export default SkillFacetInput
